import { arrayToString } from './arrayToString';

import { getNominationRoundYear } from './getNominationRoundYear';

export const tableRowsValuesNominationHistory = (
  resultData,
  proposers,
  electionTypes,
  nominationStatusType,
  sectionalCommitteesWithCmse,
  fellows,
) =>
  resultData.map((item) => {
    const disciplineDescriptorLabels = arrayToString(
      item.attributes.disciplineDescriptor,
    );
    const overlapDisciplineDescriptorLabels = arrayToString(
      item.attributes.overlapDisciplineDescriptor,
    );
    const interdisciplinaryCommitteeLabels = arrayToString(
      item.attributes.interdisciplinaryCommittee,
    );

    let sectionalCommitteeKey = item.attributes.sectionalCommitteeId;
    if (
      item.attributes.electionTypeId &&
      parseInt(item.attributes.electionTypeId) !== 2
    ) {
      sectionalCommitteeKey = 14;
    }

    const currentNomination = resultData
      ? resultData.find(
          (nominationItem) =>
            nominationItem?.attributes?.nominationId ===
            item?.attributes?.nominationId,
        )
      : [];

    const roundYear = currentNomination?.attributes?.roundYear;
    const lastConsideredDate =
      currentNomination?.attributes?.lastConsideredDate;

    const lastConsidered = lastConsideredDate
      ? getNominationRoundYear(new Date(lastConsideredDate))
      : '';

    const nominationYear = item?.attributes?.year;

    const nominationRoundYear = nominationYear
      ? getNominationRoundYear(new Date(nominationYear))
      : '';

    const { nominationId } = item.attributes;

    return {
      nominationId,
      candidateId: item.attributes.candidateId,
      candidate: item.attributes.candidate,
      proposerName: fellows[proposers[nominationId]],
      electionTypeId: electionTypes[item.attributes.electionTypeId],
      nominationStatusType:
        nominationStatusType[item.attributes.nominationStatusTypeId],
      nominationStatusTypeId: item.attributes.nominationStatusTypeId,
      sectionalCommitteeId:
        item.attributes.deprecatedSectionalCommitteeLabel ??
        sectionalCommitteesWithCmse[sectionalCommitteeKey] ??
        '',
      overlapSectionalCommitteeId:
        sectionalCommitteesWithCmse[
          item.attributes.overlapSectionalCommitteeId
        ],
      year: nominationRoundYear,
      roundYear,
      lastConsidered,
      overlapDisciplineDescriptor: overlapDisciplineDescriptorLabels,
      disciplineDescriptor: disciplineDescriptorLabels,
      interdisciplinaryCommittee: interdisciplinaryCommitteeLabels,

      createdAt: item.attributes.createdAt,
      updatedAt: item.attributes.publishedAt,
      publishedAt: item.attributes.updatedAt,
    };
  });
